import { render, staticRenderFns } from "./GhostLegView.vue?vue&type=template&id=534c0e33&"
import script from "./GhostLegView.vue?vue&type=script&lang=js&"
export * from "./GhostLegView.vue?vue&type=script&lang=js&"
import style0 from "./GhostLegView.vue?vue&type=style&index=0&id=534c0e33&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports